import { render } from "./index.vue?vue&type=template&id=a5427b62&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a5427b62&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5427b62"],['__file',"src/components/MindMapNode/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5427b62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5427b62', __exports__)) {
    api.reload('a5427b62', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=a5427b62&scoped=true", () => {
    api.rerender('a5427b62', render)
  })

}


export default __exports__